import * as React from "react";
import Modal from "../../../ui/modal/Modal";
import SingleFileSelector from "../../../file/SingleFileSelector";
import Toast from "../../../helper/Toast";
import {Option, option} from "ts-option";
import {api} from "../../../../api/api";
import {ImportResult} from "../../../../model/importResult/ImportResult";
import Merchant from "../../../../model/merchant/Merchant";
import {TypeOfData} from "../MerchantConfigView";

interface Props {
	/**
	 * On successful merchant branch locations upload callback.
	 * @param {TypeOfData} typeOfData
	 */
	onSuccess?: (typeOfData: TypeOfData) => void;
	/**
	 * All merchants.
	 */
	merchants: Option<Merchant[]>;
	/**
	 * Merchant identifier.
	 */
	merchantId: string
	/**
	 * On close modal callback.
	 */
	onClose: () => void;
	/**
	 * Type of uploaded file data
	 */
	typeOfData: TypeOfData
}

interface IState {
	/**
	 * Indicates if files are uploading
	 */
	filesUploading: boolean;
	/**
	 * Upload errors to display
	 */
	errors: string[];
}

export default class UploadMerchantDataFileModal extends React.Component<Props, IState> {
	merchantName = "";

	constructor(props: Props) {
		super(props);
		this.state = {filesUploading: false, errors: []};
		this.uploadFile = this.uploadFile.bind(this);
		const merchant = this.props.merchants.flatMap(
			merchants => option(merchants.filter(m => m.id === this.props.merchantId)[0])
		);
		merchant.map(merchant => this.merchantName = merchant.name);
	}

	render() {
		const typeOfData = this.props.typeOfData;
		return (
			<Modal onCloseClicked={this.props.onClose} title={`Upload merchant ${typeOfData} / ${this.merchantName}`}>
				<SingleFileSelector onUpload={(file) => this.uploadFile(file, typeOfData)}
									onCancel={this.props.onClose}
									errors={option(this.state.errors)}
									filesUploading={this.state.filesUploading}/>
			</Modal>
		);
	}

	/**
	 * Upload file
	 * @param {File} file
	 * @param {TypeOfData} typeOfData
	 */
	uploadFile(file: File, typeOfData: TypeOfData) {
		if (file) {
			this.setState({filesUploading: true}, () => {
				api.instance.merchantApi.uploadMerchantFile(this.props.merchantId, file, typeOfData).then(() => {
					Toast.success(`Merchant ${typeOfData} uploaded successfully.`, `Merchant ${typeOfData} upload`);
					this.setState({filesUploading: false});
					this.props.onSuccess && this.props.onSuccess(typeOfData);
					this.props.onClose();
				}).catch((error: any) => {
					const errors = ImportResult.fromJson(error.response.data);
					this.setState({errors: errors.error, filesUploading: false});
					Toast.error(`Cannot upload merchant ${typeOfData}.`, `Merchant ${typeOfData} upload`);
				});
			});
		}
	}
}
